/* Soles District - SD Browse Kit (core JS)
   Defensive by design: every feature no-ops when its markup is absent. */
(function () {
  'use strict';

  if (window.__sdKitLoaded) return;
  window.__sdKitLoaded = true;

  var doc = document;

  /* ------------------------------------------------------------------
     1. Sticky mobile add-to-cart
     ------------------------------------------------------------------ */
  function stickyAtc() {
    var bar = doc.querySelector('[data-sd-atc]');
    if (!bar) return;
    // Find the button first, then its own form. Dawn also renders a Shop Pay
    // installments form pointing at /cart/add, and that one has no add button.
    var realBtn = doc.querySelector('product-form [name="add"], [name="add"]');
    if (!realBtn) return;
    var form = realBtn.closest('form') || realBtn.form;
    if (!form) return;

    var proxy = bar.querySelector('[data-sd-atc-btn]');
    var priceEl = bar.querySelector('[data-sd-atc-price]');
    var livePrice = doc.querySelector('.price__container .price-item--sale, .price__container .price-item--regular');

    function sync() {
      var disabled = realBtn.hasAttribute('disabled');
      proxy.disabled = disabled;
      var label = realBtn.querySelector('span');
      proxy.textContent = disabled ? 'Sold out' : (label ? label.textContent.trim() : 'Add to cart');
      if (priceEl && livePrice) priceEl.textContent = livePrice.textContent.trim();
    }

    proxy.addEventListener('click', function () {
      realBtn.click();
      if (window.matchMedia('(max-width: 989px)').matches) {
        realBtn.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    });

    bar.classList.add('is-on');
    sync();

    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(form, { attributes: true, childList: true, subtree: true });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting); });
      }, { rootMargin: '0px 0px -40px 0px' }).observe(realBtn);
    } else {
      bar.classList.add('is-visible');
    }
  }

  /* ------------------------------------------------------------------
     2. Endless collection browsing with back-button position restore
     ------------------------------------------------------------------ */
  function endless() {
    if (!doc.querySelector('[data-sd-endless]')) return;
    var grid = doc.getElementById('product-grid');
    if (!grid) return;
    var wrapper = doc.querySelector('.pagination-wrapper');
    if (!wrapper) return;

    // Page numbers are computed, not scraped, so this works whether the theme
    // renders a "next" arrow or plain numbered pagination.
    var params = new URLSearchParams(location.search);
    var firstPage = parseInt(params.get('page'), 10) || 1;
    var lastPage = firstPage;
    var key = 'sd:' + location.pathname + '?' + (function () {
      var p = new URLSearchParams(location.search);
      p.delete('page');
      return p.toString();
    })();
    var busy = false;
    var restoring = false;
    var done = false;

    function urlForPage(n) {
      var p = new URLSearchParams(location.search);
      p.set('page', String(n));
      return location.pathname + '?' + p.toString();
    }

    var sentinel = doc.createElement('div');
    sentinel.setAttribute('data-sd-sentinel', '');
    sentinel.style.cssText = 'height:1px;width:100%';
    wrapper.parentNode.insertBefore(sentinel, wrapper);

    var status = doc.createElement('div');
    status.className = 'sd-loadmore';
    status.innerHTML = '<button type="button" class="sd-loadmore__btn">Load more</button>';
    wrapper.parentNode.insertBefore(status, wrapper);
    wrapper.classList.add('sd-inf-on');

    function finish() {
      done = true;
      if (status.parentNode) status.remove();
    }

    function loadNext(silent) {
      if (busy || done) return Promise.resolve(false);
      busy = true;
      status.classList.add('is-loading');
      var page = lastPage + 1;
      return fetch(urlForPage(page))
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var dom = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = dom.getElementById('product-grid');
          var added = 0;
          if (newGrid) {
            Array.prototype.forEach.call(newGrid.children, function (li) {
              grid.appendChild(li.cloneNode(true));
              added += 1;
            });
          }
          busy = false;
          status.classList.remove('is-loading');
          if (!added) { finish(); return false; }
          lastPage = page;
          var nw = dom.querySelector('.pagination-wrapper');
          wrapper.innerHTML = nw ? nw.innerHTML : '';
          if (!silent) save();
          if (!wrapper.querySelector('a[href*="page="]')) finish();
          return true;
        })
        .catch(function () {
          busy = false;
          status.classList.remove('is-loading');
          wrapper.classList.remove('sd-inf-on');
          finish();
          return false;
        });
    }

    function save() {
      if (restoring) return;
      try { sessionStorage.setItem(key, JSON.stringify({ pages: lastPage, y: window.scrollY })); } catch (e) {}
    }

    status.querySelector('.sd-loadmore__btn').addEventListener('click', function () {
      loadNext(false);
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && !restoring) loadNext(false);
      }, { rootMargin: '900px 0px' }).observe(sentinel);
    }

    var saveTimer;
    window.addEventListener('scroll', function () {
      clearTimeout(saveTimer);
      saveTimer = setTimeout(save, 180);
    }, { passive: true });

    // Coming back from a product page: rebuild what they were looking at,
    // then put them back where they were. Any scroll input aborts the restore.
    var stored = null;
    try { stored = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
    if (stored && stored.pages > firstPage) {
      restoring = true;
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      var abort = function () { restoring = false; };
      window.addEventListener('wheel', abort, { passive: true, once: true });
      window.addEventListener('touchstart', abort, { passive: true, once: true });

      (function step() {
        if (!restoring || done || lastPage >= stored.pages) {
          restoring = false;
          if (stored.y) window.scrollTo(0, stored.y);
          return;
        }
        loadNext(true).then(function (ok) {
          if (ok) step();
          else { restoring = false; if (stored.y) window.scrollTo(0, stored.y); }
        });
      })();
    }
  }

  /* ------------------------------------------------------------------
     3. Chip rows: remember horizontal scroll between pages
     ------------------------------------------------------------------ */
  function chipMemory() {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-sd-chips]'), function (row) {
      var k = 'sdchips:' + row.getAttribute('data-sd-chips');
      try {
        var v = sessionStorage.getItem(k);
        if (v) row.scrollLeft = parseInt(v, 10) || 0;
      } catch (e) {}
      var t;
      row.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          try { sessionStorage.setItem(k, String(row.scrollLeft)); } catch (e) {}
        }, 150);
      }, { passive: true });
      // Centre the active chip if one is marked
      var active = row.querySelector('.sd-chip[aria-current="page"]');
      if (active && !row.scrollLeft) {
        row.scrollLeft = Math.max(0, active.offsetLeft - row.clientWidth / 2 + active.clientWidth / 2);
      }
    });
  }

  /* ------------------------------------------------------------------
     4. Marquee: duplicate the track, then drive it by scroll position so the
        rail can be dragged with a finger and picks itself back up on its own.
     ------------------------------------------------------------------ */
  function marquee() {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-sd-marquee]'), function (track) {
      if (track.dataset.sdCloned) return;
      track.dataset.sdCloned = '1';
      track.innerHTML += track.innerHTML;

      var box = track.parentElement;
      if (!box) return;

      // Swap the CSS keyframe for a scroll-driven loop. The keyframe stays as
      // the no-JS fallback; native scrolling is what makes it draggable.
      box.classList.add('sd-marquee--drag');
      track.style.animation = 'none';

      var half = 0;
      function measure() { half = track.scrollWidth / 2; }
      measure();
      window.addEventListener('resize', measure, { passive: true });
      window.addEventListener('load', measure, { once: true });

      var holding = false;   // finger or button is down
      var idle = null;       // resume timer after the last input
      var hovering = false;
      var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      function nudge(ms) {
        clearTimeout(idle);
        idle = setTimeout(function () { idle = null; }, ms || 1600);
      }

      // A native overflow container scrolls under a trackpad or a finger but
      // ignores a mouse press, so grab-and-drag is wired up by hand.
      var dragging = false, startX = 0, startScroll = 0, moved = 0, captured = false;
      box.addEventListener('pointerdown', function (e) {
        holding = true; nudge();
        if (e.pointerType === 'touch') return;
        dragging = true; moved = 0; captured = false;
        startX = e.clientX; startScroll = box.scrollLeft;
      });
      box.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > moved) moved = Math.abs(dx);
        // Same lazy capture as the static rails - see the note in dragRails.
        if (moved <= 5) return;
        if (!captured) {
          captured = true;
          try { box.setPointerCapture(e.pointerId); } catch (err) {}
        }
        box.scrollLeft = startScroll - dx;
      });
      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        if (captured) { try { box.releasePointerCapture(e.pointerId); } catch (err) {} }
        captured = false;
      }
      box.addEventListener('pointerup', endDrag);
      box.addEventListener('pointercancel', endDrag);
      // Let go after an actual drag and you meant to scroll, not to open a brand.
      box.addEventListener('click', function (e) {
        if (moved > 5) { e.preventDefault(); e.stopPropagation(); }
        moved = 0;
      }, true);
      ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(function (e) {
        box.addEventListener(e, function () { holding = false; nudge(); }, { passive: true });
      });
      box.addEventListener('touchstart', function () { holding = true; nudge(); }, { passive: true });
      box.addEventListener('wheel', function () { nudge(); }, { passive: true });
      box.addEventListener('scroll', function () { if (holding) nudge(); }, { passive: true });

      if (finePointer) {
        box.addEventListener('mouseenter', function () { hovering = true; });
        box.addEventListener('mouseleave', function () { hovering = false; });
      }

      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var last = 0;
      // Track the position as a float. Nudging scrollLeft by ~0.7px a frame
      // rounds away to nothing; carrying our own position does not.
      var pos = box.scrollLeft;
      var applied = pos;

      // The rail used to start drifting the instant the page loaded. On a phone
      // the hero fills the screen, so by the time anyone scrolled down to look
      // at the brands the first few had already slid off the left edge - and
      // the first few are the best sellers. Vale sits at x=0 and was gone about
      // 1.3 seconds in, with a two-minute loop before it came back, so in
      // practice nobody ever saw it. Holding the rail at the top of the list
      // until it is actually on screen is what puts those names in front of
      // people, and it stops the loop burning a frame callback while the rail
      // is nowhere near the viewport.
      // Where to be sitting when the rail first comes into view: parked on the
      // last three brands, with the front of the list - the best sellers -
      // queued up immediately to their right. The track is duplicated, so the
      // item at offset `half` is the first brand all over again; landing just
      // short of that means the top names scroll in under the reader's eye a
      // second or two after the rail appears, which is the moment they are
      // actually being looked at. Starting at 0 put those names on screen but
      // static, and starting from a cold page load meant they were gone before
      // anyone had scrolled far enough to see the rail at all.
      function tailStart() {
        var kids = track.children;
        var n = Math.floor(kids.length / 2);
        if (!n) return 0;
        var i = n - Math.min(3, n);
        return Math.max(0, kids[i].offsetLeft - kids[0].offsetLeft);
      }

      var onScreen = true, primed = true;
      if ('IntersectionObserver' in window) {
        onScreen = false; primed = false;
        new IntersectionObserver(function (entries) {
          onScreen = entries[0].isIntersecting;
          if (onScreen && !primed) {
            primed = true;
            measure();
            pos = tailStart();
            box.scrollLeft = pos;
            applied = box.scrollLeft;
            pos = applied;
          }
        }, { threshold: 0.35 }).observe(box);
      }

      function step(t) {
        var dt = last ? Math.min(t - last, 64) : 16;
        last = t;
        // Moved by anything other than us? Adopt the reader's position.
        if (Math.abs(box.scrollLeft - applied) > 1) pos = box.scrollLeft;
        if (!reduced && !holding && !idle && !hovering && onScreen && half > 0) pos += dt * 0.045;
        if (half > 0) {
          if (pos >= half) pos -= half;
          else if (pos < 0) pos += half;
        }
        box.scrollLeft = pos;
        applied = box.scrollLeft;
        window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    });
  }

  /* ------------------------------------------------------------------
     5. Static rails: no drift, but a mouse should still be able to drag
        them the way a finger already can.
     ------------------------------------------------------------------ */
  function dragRails() {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-sd-drag]'), function (box) {
      if (box.dataset.sdDragOn) return;
      box.dataset.sdDragOn = '1';
      /* Pointer capture is what broke every product link on desktop. Calling
         setPointerCapture on pointerdown makes the browser retarget the
         click that follows to the capturing element - this scroller - instead
         of the card the mouse was actually over, so the anchor never fired
         and nothing opened. Touch returned early, so phones were unaffected,
         and View all sits outside the scroller, which is why the buttons kept
         working. Capture is only needed once a drag is genuinely under way,
         so it is taken lazily, after the pointer clears the same 5px
         threshold the click handler already uses. A plain click never
         captures, and therefore never gets stolen. */
      var dragging = false, startX = 0, startScroll = 0, moved = 0, captured = false;
      box.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        dragging = true; moved = 0; captured = false;
        startX = e.clientX; startScroll = box.scrollLeft;
      });
      box.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > moved) moved = Math.abs(dx);
        if (moved <= 5) return;
        if (!captured) {
          captured = true;
          try { box.setPointerCapture(e.pointerId); } catch (err) {}
        }
        box.scrollLeft = startScroll - dx;
      });
      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        if (captured) { try { box.releasePointerCapture(e.pointerId); } catch (err) {} }
        captured = false;
      }
      box.addEventListener('pointerup', endDrag);
      box.addEventListener('pointercancel', endDrag);
      // A drag that ends on a product should scroll, not open it.
      box.addEventListener('click', function (e) {
        if (moved > 5) { e.preventDefault(); e.stopPropagation(); }
        moved = 0;
      }, true);
    });
  }

  /* ------------------------------------------------------------------
     6. Header height as a CSS variable (for sticky offsets)
     ------------------------------------------------------------------ */
  function headerVar() {
    var h = doc.querySelector('.section-header, #shopify-section-header');
    if (!h) return;
    var set = function () {
      doc.documentElement.style.setProperty('--sd-header-h', h.offsetHeight + 'px');
    };
    set();
    window.addEventListener('resize', set, { passive: true });
  }


  /* ---------------------------------------------------------------------
     Size chips add their filter to whatever is already filtered, instead of
     replacing it. The links are written server-side as a bare
     ?filter.v.option.size=L on the collection path, so following one from a
     page already filtered to Supreme threw the brand away and left you looking
     at every large in the shop. Liquid cannot read the current query string,
     so the merge happens here: on load, every chip pointing at the page you
     are already on has that page's own filters folded into its href.
     Rewriting the href rather than intercepting the click keeps middle-click,
     long-press and "open in new tab" working.
     A chip whose filter is already active becomes a remove-this-filter link
     and is marked, so a size can be cleared without the back button.
     --------------------------------------------------------------------- */
  function mergeFilters() {
    if (!window.URL || !window.URLSearchParams) return;
    var here;
    try { here = new URL(window.location.href); } catch (e) { return; }

    var chips = doc.querySelectorAll('[data-sd-chips] a.sd-chip');
    for (var i = 0; i < chips.length; i++) {
      var a = chips[i];
      var raw = a.getAttribute('href') || '';
      if (raw.indexOf('filter.') === -1) continue;

      var target;
      try { target = new URL(raw, window.location.origin); } catch (e) { continue; }
      /* Only merge into a rail that filters the collection you are on. A chip
         pointing somewhere else is navigation, not a filter. */
      if (target.pathname !== here.pathname) continue;

      var params = new URLSearchParams(here.search);
      params.delete('page');

      var own = [];
      target.searchParams.forEach(function (v, k) { own.push([k, v]); });
      if (!own.length) continue;

      var active = true;
      for (var j = 0; j < own.length; j++) {
        if (params.getAll(own[j][0]).indexOf(own[j][1]) === -1) { active = false; break; }
      }

      if (active) {
        for (var d1 = 0; d1 < own.length; d1++) params.delete(own[d1][0]);
        a.classList.add('sd-chip--on');
        a.setAttribute('aria-current', 'true');
      } else {
        for (var s1 = 0; s1 < own.length; s1++) params.set(own[s1][0], own[s1][1]);
        a.classList.remove('sd-chip--on');
        a.removeAttribute('aria-current');
      }

      var qs = params.toString();
      a.setAttribute('href', target.pathname + (qs ? '?' + qs : ''));
    }
  }

  function init() {
    try { stickyAtc(); } catch (e) {}
    try { endless(); } catch (e) {}
    try { chipMemory(); } catch (e) {}
    try { mergeFilters(); } catch (e) {}
    try { marquee(); } catch (e) {}
    try { dragRails(); } catch (e) {}
    try { headerVar(); } catch (e) {}
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();

  doc.addEventListener('shopify:section:load', init);
})();
